<script setup lang="ts">
import { MAPPED_ROUTE_NAMES } from "~/constants/routes";
import ReferralBanner from "~/components/TopBanner/Referrals/ReferralBanner.vue";
import PromoCodeBanners from "~/components/TopBanner/Promos/PromoCodeBanners.vue";
import ReferralRedemptionLimitBanner from "~/components/TopBanner/Referrals/ReferralRedemptionLimitBanner.vue";

const route = useRoute();
const cartStore = useCartStore();

const canShowCart = computed(() => {
  if (
    route.name === MAPPED_ROUTE_NAMES.SIGNUP ||
    route.name === MAPPED_ROUTE_NAMES.ONBOARDING_PLANS
  )
    return false;

  return cartStore.isCartOpen;
});

const canShowFooter = computed(
  () => route.name === MAPPED_ROUTE_NAMES.ONBOARDING_PLANS
);
</script>

<template>
  <div
    class="tw-min-h-[calc(var(--vh)-var(--om-floating-height))] tw-flex tw-flex-col tw-bg-nl-yellow-100 tw-text-nl-green-100 tw-antialiased"
  >
    <div
      class="tw-sticky tw-top-[var(--om-floating-height)] tw-right-0 tw-left-0 tw-z-[51]"
    >
      <client-only>
        <PromoCodeBanners/>
      </client-only>
      <ReferralBanner/>
      <ReferralRedemptionLimitBanner/>
      <RegflowProgress class="tw-w-full"/>
    </div>

    <main id="content" class="tw-flex-1 tw-flex tw-flex-col">
      <slot/>
    </main>
    <Cart v-if="canShowCart"/>

    <Footer v-if="canShowFooter" class="tw-block md:tw-hidden"/>
  </div>
</template>
<script setup lang="ts"></script>
